export default __webpack_public_path__ + "static/media/fish-rMIN.jpg.4d9f43c1.txt";